<script>
import MainContainer from '@/components/container/MainContainer.vue';
import LeftPanel from '@/components/container/LeftPanel.vue';
import RightContainer from '@/components/container/RightContainer.vue';
import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

import SystemSettingsHeader from '@/components/page-system-settings/SystemSettingsHeader.vue';
import SystemSettingsList from '@/components/page-system-settings/SystemSettingsList.vue';
import SystemSettingsActions from '@/components/page-system-settings/SystemSettingsActions.vue';

import { promiseAll, calculatePromise } from '@/api/default.js';

export default {
    components: {
        MainContainer,
        LeftPanel,
        RightContainer,
        ButtonReturn,
        SystemSettingsHeader,
        SystemSettingsList,
        SystemSettingsActions,
    },
    async mounted() {
        this.$store.commit('IS_LOAD', true);

        const promiseList = await calculatePromise([
            { dispatch: 'loadSystemSettings', commit: null, isArray: false },
        ]);

        await promiseAll(promiseList);

        this.$store.commit('IS_LOAD', false);
    },
};
</script>

<template>
    <MainContainer>
        <LeftPanel>
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <div class="system_settings_page">
                <SystemSettingsHeader />
                <hr class="hr_light_98" />
                <SystemSettingsList />
                <hr class="hr_light_98" />
                <SystemSettingsActions />
            </div>
        </RightContainer>
    </MainContainer>
</template>

<style scoped>
.system_settings_page {
    padding: 0;
}

.hr_light_98 {
    border: none;
    height: 1px;
    background-color: var(--border-color);
    margin: 0;
}
</style>
